<template>
    <div>
        <v-server-table ref="nonCompliantTable" url="/reports/non-compliant-items" :columns="columns" :options="options">

            <template slot="corrective_action_id" slot-scope="props">
                <router-link :to="`/corrective-actions/view/${props.row.corrective_action_id}`" title="View Corrective Action" class="btn btn-xs btn-secondary">
                    View CA
                </router-link>
            </template>

            <template slot="Id" slot-scope="props">
                <router-link :to="`/inspections/result/${props.row.Id}`" title="View Inspection Result" class="btn btn-xs btn-light ml-1" v-if="props.row.asset_type == 'InspectionResult'">
                    View Result
                </router-link>
                <router-link :to="`/corrective-actions/view/${props.row.Id}`" title="View Observation" class="btn btn-xs btn-light ml-1" v-if="props.row.asset_type == 'Observation'">
                    View Obsv.
                </router-link>
            </template>

            <router-link slot="JobsiteName" slot-scope="props" :to="`/jobsites/view/${props.row.JobsiteId}`" title="View Jobsite">
                {{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}
            </router-link>

            <template slot="ElementOrder" slot-scope="props">
                {{props.row.SectionOrder}}.{{props.row.ElementOrder}}
            </template>

            <template slot="status_name" slot-scope="props">
                <label :class="`badge badge-${props.row.status_color}`">{{ props.row.status_name }}</label>
            </template>

            <template slot="ItemDate" slot-scope="props">
                {{ props.row.ItemDate | moment("MM/DD/YYYY") }}
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        props: ['timeFilter'],

        data: function() {
            return {
                columns: ['corrective_action_id', 'Id', 'JobsiteName', 'ElementOrder', 'SectionName', 'ElementText', 'status_name', 'detail', 'completed_detail', 'creator_name', 'assignee_name', 'ItemDate'],
                options: {
                    headings: {
                        corrective_action_id: 'View',
                        Id: 'Result',
                        JobsiteName: 'Jobsite',
                        ElementOrder: 'Item',
                        SectionName: 'Section',
                        ElementText: 'Element',
                        status_name: 'Status',
                        detail: 'Detail',
                        completed_detail: 'Completed Detail',
                        creator_name: 'Created By',
                        assignee_name: 'Assigned To',
                        ItemDate: 'Date'
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('noncompliantListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Set the filters
                        data.filters = {
                            'NonCompliant_ItemDate': this.timeFilter.toLowerCase(),
                        };

                        this.getPreviousData();

                        //Send it
                        return data;
                    },
                    uniqueKey: 'corrective_action_id',
                    orderBy: {
                        ascending: false,
                        column: 'ItemDate',
                    }
                },
            }
        },

        methods: {
            getPreviousData: function() {
                this.$http.get('/reports/non-compliant-items', {'filters': {'NonCompliant_ItemDate': 'prev_'+this.timeFilter.toLowerCase()}})
                .then(response => {
                    this.$emit('prevNoncompliantListCount', response.data.count);
                })
                .catch(err => {

                })
                .then(() => {

                });
            },
        },
    }
</script>
